

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Import the functions you need from the SDKs you need
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDAqg85dzfpORq-EqIwwYdWdQh65819Ny8",
  authDomain: "pharmacy-e-commerce-61140.firebaseapp.com",
  projectId: "pharmacy-e-commerce-61140",
  storageBucket: "pharmacy-e-commerce-61140.firebasestorage.app",
  messagingSenderId: "133219029999",
  appId: "1:133219029999:web:3dc8a33fe9360cf44d5c1a",
  measurementId: "G-KS9QQX9JKK"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Initialize Firebase
const analytics = getAnalytics(app);
// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;

